<style lang="scss" scoped>
.outBox {
    width: 100%;
    height: 100%;
}

#dicom_panel {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 4px;
    .cateyes-frame {
        width: 100%;
        height: 100%;
        border: none;
        overflow: hidden;
        right: 0px;
    }
}
</style>
<template>
    <div class="outBox">
        <div class="panel" id="dicom_panel"></div>
    </div>
</template>
<script>
import '../../utils/jquery-3.3.1.js'
export default {
    data() {
        return {
        }
    },
    props: ["choice"],
    computed: {
        cateyesUrl() {
            let studyIds = window.location.href.split('?')[1].split('&')[0].split('=')[1]
            var url = `/cateyes/cateyes.html?studyIds=${studyIds}&show=true`;
            return url;
        },
    },
    methods: {
        initData() {
            document.getElementById("dicom_panel").innerHTML = "";
            var iframe = document.createElement('iframe');
            document.getElementById("dicom_panel").appendChild(iframe);
            iframe.src = this.cateyesUrl;
            iframe.className = "cateyes-frame";
            iframe.style.width = "100%";
            iframe.style.height = "100%";
            iframe.style.border = "0";
            // window.CateyesPubSub = $({});
        }
    },
    mounted() {
        this.initData()
    }

}
</script>



// WEBPACK FOOTER //
// src/components/Peaimage/Peaimage.vue